import ShareableLinkProvider from './ShareableLink.provider';

export default ShareableLinkProvider;
